import type { IFindAutocompleteItem } from './find-autocomplete-item.model';

export default class FindAutocompleteItemApiModel {
  public static mapToBusinessModel(apiModel: FindAutocompleteItemApiModel): IFindAutocompleteItem {
    return { query: apiModel.query };
  }

  public query!: string;
  public type!: string;
}
